// Stub for node:dns — not available in browser
// borogove's XmppJsStream calls dns.lookup(); returning empty success triggers WebSocket fallback
export default {
	lookup: (x, y, cb) => cb(null, []),
	resolveSrv: (x, cb) => cb(null, []),
};
